import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const userAgent = navigator.userAgent.toLowerCase;
const isSmallScreen = window.innerWidth <= 768;
let ismobile =  /android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(userAgent) || isSmallScreen;
// console.log(ismobile,'=================================')

const Home = () => import('@/views/Home'); // 静态导入（按需加载）
const mHome = () => import('@/mobile/Home'); // 静态导入（按需加载）


const index = () => import('@/views/index'); // 静态导入（按需加载）
const mIndex = () => import('@/mobile/index'); // 静态导入（按需加载）


const product = () => import('@/views/product'); // 静态导入（按需加载）
const mProduct = () => import('@/mobile/product'); // 静态导入（按需加载）

const consumerUseCase = () => import('@/views/consumerUseCase'); // 静态导入（按需加载）
const mConsumerUseCase = () => import('@/mobile/consumerUseCase'); // 静态导入（按需加载）

const supplyChain = () => import('@/views/supplyChain'); // 静态导入（按需加载）
const mSupplyChain = () => import('@/mobile/supplyChain'); // 静态导入（按需加载）

const customer = () => import('@/views/customer'); // 静态导入（按需加载）
const mCustomer = () => import('@/mobile/customer'); // 静态导入（按需加载）

const superOrder = () => import('@/views/superOrder'); // 静态导入（按需加载）
const mSuperOrder = () => import('@/mobile/superOrder'); // 静态导入（按需加载）

const risk = () => import('@/views/risk'); // 静态导入（按需加载）
const mRisk = () => import('@/mobile/risk'); // 静态导入（按需加载）

const finance = () => import('@/views/finance'); // 静态导入（按需加载）
const mFinance = () => import('@/mobile/finance'); // 静态导入（按需加载）

const table = () => import('@/views/table'); // 静态导入（按需加载）
const mTable = () => import('@/mobile/table'); // 静态导入（按需加载）


const aboutUs = () => import('@/views/aboutUs'); // 静态导入（按需加载）
const mAboutUs = () => import('@/mobile/aboutUs'); // 静态导入（按需加载）

const joinUs = () => import('@/views/joinUs'); // 静态导入（按需加载）
const mJoinUs = () => import('@/mobile/joinUs'); // 静态导入（按需加载）

const newsCenter = () => import('@/views/newsCenter'); // 静态导入（按需加载）
const mNewsCenter = () => import('@/mobile/newsCenter'); // 静态导入（按需加载）


const routes = [
  {
    path: '/',
    name: 'home',
    component: ismobile?mHome:Home,
    redirect: '/index',
    children:[
      {
        path: 'index',
        name: 'index',
        meta:{title:'金豆子数科 - 科技赋能助力新增长',keepAlive:false},
        component: ismobile?mIndex:index
      },
      {
        path: 'newsCenter',
        name: 'newsCenter',
        meta:{title:'新闻中心'},
        component: ismobile?mNewsCenter:newsCenter
      },
      {
        path: 'product',
        name: 'product',
        meta:{title:'产品'},
        component: ismobile?mProduct:product
      },
      {
        path: 'consumerUseCase',
        name: 'consumerUseCase',
        meta:{title:'消费场景解决方案'},
        component: ismobile?mConsumerUseCase:consumerUseCase
      },
      {
        path: 'supplyChain',
        name: 'supplyChain',
        meta:{title:'供应链解决方案'},
        component: ismobile?mSupplyChain:supplyChain
      },
      
      {
        path: 'customer',
        name: 'customer',
        meta:{title:'客户管理系统'},
        component: ismobile?mCustomer:customer
      },

      {
        path: 'superOrder',
        name: 'superOrder',
        meta:{title:'超级订单系统'},
        component: ismobile?mSuperOrder:superOrder
      },

      {
        path: 'risk',
        name: 'risk',
        meta:{title:'智能风控系统'},
        component: ismobile?mRisk:risk
      },

      {
        path: 'finance',
        name: 'finance',
        meta:{title:'智能财务系统'},
        component: ismobile?mFinance:finance
      },

      {
        path: 'table',
        name: 'table',
        meta:{title:'智能报表系统'},
        component: ismobile?mTable:table
      },
      
      {
        path: 'aboutUs',
        name: 'aboutUs',
        meta:{title:'关于我们'},
        component: ismobile?mAboutUs:aboutUs
      },
      {
        path: 'joinUs',
        name: 'joinUs',
        meta:{title:'加入我们'},
        component: ismobile?mJoinUs:joinUs
      },
      // {
      //   path: 'detail',
      //   name: 'detail',
      //   meta:{title:'详情'},
      //   component: ()=>import('@/views/detail')
      // }
    ]
  }
]
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}


const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes
})

// import NProgress from "nprogress";
// import "nprogress/nprogress.css";
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '广东金豆子数字科技有限公司';
  // 开始进度条
  // NProgress.start();
  next()
});

// router.afterEach((to, from, next) => {

//   // 结束进度条
//   NProgress.done();
// });

export default router
